module.exports = __webpack_public_path__ + "img/pic_logo@2x.17b610e0.svg";